module.exports = __webpack_public_path__ + "static/media/arrow_forward_iframe.7c020429.svg";